import styles from './ccf-no-request-found-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfNoRequestFoundIconProps extends SvgIconProps {}

/**
 * Component used to display  No Request Icon
 * @param props - CcfNoRequestFoundIcon
 * @example - <CcfNoRequestFoundIcon />
 */
export function CcfNoRequestFoundIcon(props: CcfNoRequestFoundIconProps) {
  return (
    <SvgIcon
      width="246"
      height="142"
      viewBox="0 0 246 142"
      fill="none"
      {...props}
    >
      <g clip-path="url(#clip0_2029_48344)">
        <path
          opacity="0.1"
          d="M19.094 137.362C19.094 137.362 -15.735 108.076 8.68699 80.7618C17.8 70.5678 41.066 64.8438 62.453 69.4878C75.085 72.2308 94.244 71.8258 112.964 47.6478C138.492 14.6758 244.464 29.6678 223.781 87.4378C215.068 111.772 247.544 112.879 231.457 137.419L19.094 137.362Z"
          fill="#005CB9"
        />
        <path
          d="M6.40798 136.857H245.594C245.702 136.857 245.805 136.9 245.882 136.976C245.958 137.052 246.001 137.156 246.001 137.264C246.001 137.372 245.958 137.475 245.882 137.552C245.805 137.628 245.702 137.671 245.594 137.671H6.40798C6.30003 137.671 6.19651 137.628 6.12018 137.552C6.04386 137.475 6.00098 137.372 6.00098 137.264V137.264C6.00098 137.156 6.04386 137.052 6.12018 136.976C6.19651 136.9 6.30003 136.857 6.40798 136.857V136.857Z"
          fill="#5B7C8C"
        />
        <path
          d="M150.415 62.207C150.415 62.207 164.131 62.461 161.591 64.874C159.051 67.287 149.526 64.874 149.526 64.874L150.415 62.207Z"
          fill="#FFCDD3"
        />
        <path
          d="M121.837 32.9632C121.837 32.9632 127.375 31.9742 129.3 36.4452C131.225 40.9162 135.18 53.6652 135.18 53.6652C135.18 53.6652 145.763 60.6701 147.688 60.4401C149.613 60.2101 152.903 60.6792 152.3 62.7792C151.697 64.8792 151.964 67.2601 150.575 67.5521C149.186 67.8441 146.975 65.0582 145.284 66.4002C143.593 67.7422 128.519 62.8412 127.551 61.8252C126.583 60.8092 118.541 38.8252 118.541 38.8252C118.541 38.8252 118.862 32.8922 121.837 32.9632Z"
          fill="white"
        />
        <path
          d="M133.715 127.041L134.35 132.375L129.016 133.775L125.968 132.375V127.675L133.715 127.041Z"
          fill="#FFB27D"
        />
        <path
          d="M119.363 130.47L119.998 135.804L114.664 137.204L111.616 135.804V131.104L119.363 130.47Z"
          fill="#FFB27D"
        />
        <path
          d="M134.223 68.7481L136.636 77.5111L140.192 95.2911C140.745 98.4988 140.393 101.797 139.176 104.816C137.144 110.023 133.461 127.041 134.223 128.057C134.985 129.073 125.587 129.835 125.714 128.819C125.841 127.803 127.114 113.833 127.114 113.833C127.114 113.833 128.892 101.514 129.781 99.9901C130.67 98.4661 125.717 94.6561 125.717 94.6561C125.717 94.6561 124.447 109.261 122.542 110.531C120.637 111.801 120.891 131.486 120.002 131.74C119.113 131.994 112.636 133.01 111.874 131.74C111.112 130.47 111.874 109.261 111.874 109.261C111.874 109.261 116.192 93.1321 115.303 90.8461C114.414 88.5601 114.922 78.7811 114.922 78.7811C114.922 78.7811 111.622 71.2881 113.398 67.3511L134.223 68.7481Z"
          fill="#004A72"
        />
        <path
          d="M131.89 18.4521C131.89 18.4521 128.856 26.3774 130.002 29.0807C131.147 31.7841 120.382 26.598 120.382 26.598C120.382 26.598 123.71 16.7032 123.16 15.0122C122.611 13.3213 131.89 18.4521 131.89 18.4521Z"
          fill="#FFB27D"
        />
        <path
          d="M129.778 22.9149C134.407 22.9149 138.16 19.1621 138.16 14.5329C138.16 9.90363 134.407 6.15088 129.778 6.15088C125.149 6.15088 121.396 9.90363 121.396 14.5329C121.396 19.1621 125.149 22.9149 129.778 22.9149Z"
          fill="#FFB27D"
        />
        <g filter="url(#filter0_d_2029_48344)">
          <path
            d="M112.655 64.3129C112.184 65.724 111.92 67.196 111.871 68.6828C111.914 69.5578 114.237 70.1318 117.449 70.5078C120.427 70.8568 124.17 71.0348 127.572 71.1258C131.145 71.2258 134.339 71.2258 135.872 71.2258C140.444 71.2258 136.761 68.3049 134.983 66.9079C133.205 65.5109 133.583 45.6988 133.713 43.1588C133.843 40.6188 132.57 33.2528 132.57 31.8588C132.57 30.4648 129.582 26.8158 129.582 26.8158C129.582 26.8158 128.882 28.8158 126.093 26.1438C124.253 24.4771 122.025 23.2981 119.612 22.7148C116.818 23.7308 112.119 34.9068 111.865 36.8148C111.765 37.5878 111.847 41.5498 112.02 46.0718C112.27 52.6818 112.707 60.4969 113.008 61.3259C113.144 62.3354 113.022 63.3628 112.655 64.3129Z"
            fill="white"
          />
        </g>
        <path
          d="M112.654 64.3409C112.183 65.7521 111.919 67.2241 111.87 68.7109C111.913 69.5859 114.236 70.1599 117.448 70.5359C120.426 70.8849 124.169 71.0629 127.571 71.1539C131.144 71.2539 134.338 71.2539 135.871 71.2539C140.443 71.2539 136.76 68.3329 134.982 66.9359C133.204 65.5389 133.582 45.7269 133.712 43.1869C133.842 40.6469 132.569 33.2809 132.569 31.8869C132.569 30.4929 129.581 26.8439 129.581 26.8439C129.581 26.8439 128.881 28.8439 126.092 26.1719C123.303 23.4999 121.124 23.6229 121.124 23.6229C118.33 24.6389 113.265 35.0929 113.011 36.9979C112.311 39.9796 111.98 43.0356 112.023 46.0979C112.273 52.7079 112.71 60.5229 113.011 61.3519C113.146 62.3624 113.023 63.3907 112.654 64.3409Z"
          fill="#A9DFF8"
        />
        <path
          d="M127.365 130.978C127.365 130.978 130.032 134.026 132.065 131.994C134.098 129.962 133.965 128.694 134.351 128.694C134.737 128.694 140.451 133.774 140.451 133.774C140.451 133.774 150.23 136.06 144.896 137.711C139.562 139.362 124.449 138.219 124.449 137.711C124.449 137.203 124.068 130.472 125.465 130.472L127.365 130.978Z"
          fill="#2D293D"
        />
        <path
          d="M113.014 134.407C113.014 134.407 115.681 137.455 117.714 135.423C119.747 133.391 119.614 132.123 120 132.123C120.386 132.123 126.1 137.203 126.1 137.203C126.1 137.203 135.879 139.489 130.545 141.14C125.211 142.791 110.098 141.648 110.098 141.14C110.098 140.632 109.717 133.901 111.114 133.901L113.014 134.407Z"
          fill="#2D293D"
        />
        <path
          d="M165.701 67.9182C163.329 71.3122 154.801 69.5182 154.801 69.5182L148.197 63.3312L147.308 62.4942L148.8 59.3262C148.8 59.3262 149.274 59.4562 150.088 59.6892C154.358 60.9262 167.708 65.0652 165.701 67.9182Z"
          fill="#EFB7B9"
        />
        <path
          opacity="0.1"
          d="M150.083 59.6892C149.638 60.9897 149.002 62.217 148.197 63.3312L147.308 62.4942L148.8 59.3262C148.8 59.3262 149.279 59.4562 150.083 59.6892Z"
          fill="black"
        />
        <path
          opacity="0.1"
          d="M133.714 48.2598C133.714 48.2598 132.483 50.7808 133.24 50.6098C133.997 50.4388 133.714 48.2598 133.714 48.2598Z"
          fill="black"
        />
        <path
          d="M134.31 53.3519L152.571 50.3809V67.6689L135.221 66.7609L134.31 53.3519Z"
          fill="#AB9864"
        />
        <path
          opacity="0.05"
          d="M134.31 53.3519L152.571 50.3809V67.6689L135.221 66.7609L134.31 53.3519Z"
          fill="black"
        />
        <path
          d="M152.57 50.3809L174.47 52.0199L173.257 67.0639L152.57 67.6689V50.3809Z"
          fill="#BEA96F"
        />
        <path
          opacity="0.1"
          d="M152.57 50.3809L174.47 52.0199L173.257 67.0639L152.57 67.6689V50.3809Z"
          fill="black"
        />
        <path
          d="M159.303 45.104L152.57 50.381L174.47 52.019L178.049 46.619L159.303 45.104Z"
          fill="#C5B27E"
        />
        <path
          d="M127.698 47.5879L144.137 45.5879L152.57 50.3809L134.31 53.3519L127.698 47.5879Z"
          fill="#BEA96F"
        />
        <path
          d="M156.574 54.8701V78.5061L148.02 77.6291L144.299 77.2521L143.165 77.1331L139.447 76.7521L134.31 76.2231V53.3521L152.568 54.5951L156.574 54.8701Z"
          fill="#D6C69B"
        />
        <path
          d="M174.473 52.019V75.07L167.617 76.386L164.283 77.026L156.573 78.506V54.87L174.473 52.019Z"
          fill="#C5B27E"
        />
        <path
          opacity="0.05"
          d="M174.473 52.019V75.07L167.617 76.386L164.283 77.026L156.573 78.506V54.87L174.473 52.019Z"
          fill="black"
        />
        <path
          d="M127.698 58.3271L134.31 53.3521L156.573 54.8701L153.298 60.3911L127.698 58.3271Z"
          fill="#B79F5F"
        />
        <path
          opacity="0.1"
          d="M127.698 58.3271L134.31 53.3521L156.573 54.8701L153.298 60.3911L127.698 58.3271Z"
          fill="white"
        />
        <path
          d="M174.473 52.019L156.573 54.87L162.397 60.087L181.566 56.871L174.473 52.019Z"
          fill="#BEA96F"
        />
        <path
          opacity="0.1"
          d="M174.473 52.019L156.573 54.87L162.397 60.087L181.566 56.871L174.473 52.019Z"
          fill="white"
        />
        <path
          opacity="0.1"
          d="M167.612 76.387L164.278 77.027V72.101L167.401 71.314L167.612 76.387Z"
          fill="white"
        />
        <path
          opacity="0.1"
          d="M148.02 74.3711V77.6291L144.299 77.2501V74.3711H148.02Z"
          fill="white"
        />
        <path
          d="M122.328 22.6767C122.096 22.9002 121.784 23.1411 121.485 23.022C120.016 20.7462 118.78 18.329 117.794 15.8066C117.348 14.9557 117.24 13.968 117.491 13.0407C117.673 12.7133 117.828 12.3714 117.954 12.0185C117.974 11.4515 117.917 10.8845 117.782 10.3333C117.818 9.73741 118.013 9.16209 118.347 8.6672C118.681 8.17232 119.141 7.77597 119.68 7.51942C120.759 7.0199 121.809 6.45972 122.825 5.84157C123.66 5.08004 124.445 4.26465 125.173 3.40063C125.543 2.96999 126.009 2.63373 126.535 2.4198C127.06 2.20586 127.629 2.12044 128.194 2.17064C129.176 2.36089 129.923 3.17824 130.875 3.48325C131.536 3.64131 132.216 3.70162 132.894 3.66225C134.777 3.69521 136.628 4.15391 138.308 5.00396C138.713 5.18866 139.081 5.44535 139.394 5.76156C140.852 7.36487 139.355 10.2209 140.605 11.991L138.429 10.8696C137.84 10.5271 137.202 10.2767 136.537 10.127C136.203 10.0547 135.858 10.0588 135.526 10.1389C135.195 10.2191 134.885 10.3733 134.622 10.5899C134.042 11.3573 133.751 12.3049 133.801 13.2656C133.697 14.2149 133.275 15.3269 132.334 15.4864C131.052 15.703 130.263 14.0115 129.009 13.6704C128.593 13.5875 128.162 13.6244 127.765 13.7766C127.369 13.9289 127.023 14.1903 126.769 14.5306C126.272 15.2212 125.965 16.0306 125.88 16.8774C125.834 17.4218 125.711 17.957 125.516 18.4672C125.264 19.001 124.828 19.1244 124.536 19.5439C123.911 20.6623 123.171 21.7123 122.328 22.6767Z"
          fill="#2D293D"
        />
        <path
          opacity="0.1"
          d="M119.981 32.1938C119.981 32.1938 114.23 34.3848 114.175 40.5188C114.162 44.4716 114.381 48.4218 114.832 52.3488C114.832 52.3488 113.189 61.4958 117.844 64.1248C122.499 66.7538 126.826 68.9448 126.826 68.9448C126.826 68.9448 132.745 69.1088 133.659 69.4928C134.573 69.8768 137.747 64.9468 137.259 64.1258C136.771 63.3048 131.513 62.3188 130.709 60.9488C129.987 59.9637 129.03 59.1756 127.924 58.6568C127.924 58.6568 125.904 57.2788 125.824 56.1288C125.842 55.2629 126.077 54.4154 126.507 53.6638C126.676 53.1708 127.287 48.3508 127.287 48.3508C127.287 48.3508 130.551 31.2518 119.981 32.1938Z"
          fill="black"
        />
        <path
          d="M149.342 71.4826C147.408 73.9566 141.02 72.2476 141.02 72.2476L134.89 68.1006L135.63 66.6256L136.889 64.2866C136.889 64.2866 137.249 64.4056 137.85 64.6136C141.036 65.7216 150.975 69.3976 149.342 71.4826Z"
          fill="#FFB27D"
        />
        <path
          d="M119.196 30.6098C119.196 30.6098 113.445 32.8008 113.39 38.9348C113.377 42.8876 113.596 46.8378 114.047 50.7648C114.047 50.7648 112.404 59.9118 117.059 62.5408C121.714 65.1698 126.041 67.3608 126.041 67.3608C126.041 67.3608 133.479 68.5608 134.392 68.9488C135.305 69.3368 138.48 64.4028 137.992 63.5808C137.504 62.7588 130.727 60.7328 129.923 59.3638C129.201 58.3787 128.244 57.5906 127.138 57.0718C127.138 57.0718 125.118 55.6938 125.038 54.5438C125.056 53.6779 125.291 52.8304 125.721 52.0788C125.89 51.5858 126.501 46.7658 126.501 46.7658C126.501 46.7658 129.766 29.6678 119.196 30.6098Z"
          fill="#A9DFF8"
        />
        <path
          opacity="0.1"
          d="M121.824 50.9189C121.824 50.9189 114.047 51.7949 114.649 54.5339C116.703 52.7513 119.169 51.5089 121.824 50.9189Z"
          fill="black"
        />
        <path
          opacity="0.1"
          d="M121.824 52.0146C121.824 52.0146 117.41 55.2456 118.224 55.4656C119.038 55.6856 121.824 52.0146 121.824 52.0146Z"
          fill="black"
        />
        <path
          opacity="0.1"
          d="M123.796 53.3286C123.796 53.3286 122.536 55.5936 123.248 55.4756C123.96 55.3576 123.796 53.3286 123.796 53.3286Z"
          fill="black"
        />
        <path
          d="M126.477 19.807C127.637 21.0507 129.068 22.0107 130.659 22.6126L130.054 25.3593C130.054 25.3593 124.869 17.9083 126.477 19.807Z"
          fill="#ED985F"
        />
        <path
          d="M126.6 91.4039C126.7 91.5699 125.41 94.1289 125.667 94.5699C127.761 98.1639 128.567 98.1848 130.167 100.84C130.511 93.0248 130.167 91.4039 130.167 91.4039L127.601 82.3369C126.967 85.3184 126.632 88.3559 126.601 91.4039H126.6Z"
          fill="#233862"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2029_48344"
          x="111.822"
          y="21.7148"
          width="28.2531"
          height="50.5112"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2029_48344"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2029_48344"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_2029_48344">
          <rect width="246.001" height="142" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}

export default CcfNoRequestFoundIcon;
